import { IdexxBreedModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class IdexxService {
  private static baseUrl: string = '/api/idexx';
  static tags = {
    getIdexxBreeds: 'getIdexxBreeds',
  };

  static getIdexxBreeds = (
    options?: ServiceMethodOptions,
  ): Promise<IdexxBreedModel[]> => {
    return trackPromise(
      new Promise<IdexxBreedModel[]>((resolve, reject) => {
        http(`${this.baseUrl}/breeds`)
          .get<IdexxBreedModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess('Idexx Breeds fetched.', options);
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to get Idexx Breeds.', options);
            reject(err);
          });
      }),
      this.tags.getIdexxBreeds,
    );
  };
}
